module.exports = __webpack_public_path__ + "assets/img/fica-germany.8d72d785.jpg";